import accessors from './accessors';
import middleware from './middleware';

export default {
  accessors,
  middleware,
};
